import {styled} from '@mui/material/styles';
import {Button, Typography} from '@mui/material';
import {ReactNode} from 'react';

export type TreePickerDetailsProps = {
  selectionCount: ReactNode;
  onSelectAll: () => void;
  onInverseSelection: () => void;
  onSelectNone: () => void;
  isDisabled?: boolean;
};

const SRoot = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap-reverse',
}));

const SActions = styled('div')(() => ({
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: 'max-content',
  gridGap: 8,
  alignItems: 'center',
  marginLeft: 'auto',
}));

const SSelectedWrapper = styled('div')(({theme}) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const SSelected = styled(Typography)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export default function TreePickerDetails({
  selectionCount,
  onInverseSelection,
  onSelectAll,
  onSelectNone,
  isDisabled,
}: TreePickerDetailsProps) {
  return (
    <SRoot>
      <SSelectedWrapper>
        <Typography variant='body3Bold'>Selected: </Typography>
        <SSelected variant='subtitle3'>{selectionCount || 'All'}</SSelected>
      </SSelectedWrapper>

      <SActions>
        <Button size='small' disabled={isDisabled} variant='text' onClick={onSelectAll}>
          Select All
        </Button>

        <Button size='small' disabled={isDisabled} variant='text' onClick={onInverseSelection}>
          Inverse
        </Button>

        <Button size='small' disabled={isDisabled} variant='text' onClick={onSelectNone}>
          Clear
        </Button>
      </SActions>
    </SRoot>
  );
}
